/**
 * 首页快速类目入口数据（Phase 2，2026-09-18）
 *
 * 字段语义（与 Phase 2 运营专区/数字货架规划对齐）：
 *   title          短标题（≤4 字，紧凑展示）
 *   icon           图标名（CategoryEntries.vue 内联 SVG 映射）
 *   tone           三原色档位（§4）：'blue' #3657ff / 'yellow' #ffd336 / 'orange' #ff6f36，
 *                  按类目固定映射 + 三色循环；'neutral' 仅「更多」用（克制不彩虹，
 *                  文字一律中性色 #333）。组件层只认档位名，不写死色值
 *   type           'category_hub' = 类目专区入口（Phase 2 独立 landing page）
 *                  'all_categories' = 全类目浏览（现有 /search 类目网格）
 *   target         类目 slug（categories.slug，与 products.category 同键）。
 *                  category_hub 点击 → /result?type=spec&category=<target> 规格筛选上下文
 *                  （类目默认全量，结果页按规格/车型 facet 收窄；2026-09-19 起不再走关键词搜索）
 *   search_alias   仅 target 缺失的异常配置兜底——回落 /result?id=<词> 关键词搜索
 *                  （名称/编码/车型/规格/拼音/同义词全能力，服务端 resolveSearchTerms 归一）
 *   placement_type organic / editorial / sponsored（Phase 2 数字货架陈列类型；
 *                  恒 organic，前端不得据此渲染任何"推广"标——不显示假 sponsored）
 *
 * 选品依据（§3 高频采购类目，2026-09-18 dev 库 active 商品数）：
 *   轮胎 tire 255 / 机油 oil 111 / 电瓶 battery 35（电瓶=电池 同义词互搜已覆盖）/
 *   火花塞 spark_plug 18——维保四大件，其余类目（后视镜 93 / 刹车片 79）经「更多」进全类目。
 */
export const HOME_CATEGORY_ENTRIES = [
  { title: '轮胎', icon: 'tire', tone: 'blue', type: 'category_hub', target: 'tire', search_alias: '轮胎', placement_type: 'organic' },
  { title: '电瓶', icon: 'battery', tone: 'yellow', type: 'category_hub', target: 'battery', search_alias: '电瓶', placement_type: 'organic' },
  { title: '机油', icon: 'oil', tone: 'orange', type: 'category_hub', target: 'oil', search_alias: '机油', placement_type: 'organic' },
  { title: '火花塞', icon: 'spark', tone: 'blue', type: 'category_hub', target: 'spark_plug', search_alias: '火花塞', placement_type: 'organic' },
  { title: '更多', icon: 'grid', tone: 'neutral', type: 'all_categories', target: null, search_alias: null, placement_type: 'organic' }
]
